// Remembers whether the sidebar's Community group is expanded, across reloads and
// sessions. Best-effort; storage may be unavailable (private mode, quota).

export const COMMUNITY_NAV_EXPANDED_KEY = 'ai_studio_community_nav_expanded'

export const saveCommunityNavExpanded = (isExpanded) => {
  try {
    window.localStorage.setItem(COMMUNITY_NAV_EXPANDED_KEY, String(!!isExpanded))
  } catch (_) {
    // No-op.
  }
}

export const readStoredCommunityNavExpanded = () => {
  try {
    const stored = window.localStorage.getItem(COMMUNITY_NAV_EXPANDED_KEY)
    if (stored === 'true') return true
    if (stored === 'false') return false
    return undefined
  } catch (_) {
    return undefined
  }
}
